import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { CodeBlock } from '../../CodeBlocks';
import { BasicBlockWrapper } from './BasicBlockWrapper';

/*
 * Basic renderer for a code block.
 */
export function BasicBlockCode(props: BlockProps): React.ReactElement {
    const { children, ...rest } = props;

    return (
        <BasicBlockWrapper tag="div" {...rest}>
            <CodeBlock overflow="scroll" showToolbar={false}>
                {children}
            </CodeBlock>
        </BasicBlockWrapper>
    );
}
